<template>
    <b-list-group>
        <b-list-group-item v-for="user in users" :key="user.id">
            <b-media vertical-align="center">
                <avatar
                    :src="user.picture"
                    :username="user.name"
                    slot="aside"
                    :size="40"
                />
                <b-media
                    style="margin-left: 10px"
                    right-align
                    vertical-align="center"
                >
                    <div>
                        {{ $t('insights.name') }}:
                        {{ user.name || $t('insights.notRegistered') }}
                    </div>
                    <div>
                        {{ $t('insights.team') }}:
                        {{
                            user.teams.join(', ') ||
                                $t('insights.notRegistered')
                        }}
                    </div>
                    <div>
                        {{ $t('insights.manager') }}:
                        {{ user.manager || $t('insights.notRegistered') }}
                    </div>
                    <slot slot="aside" :id="user.id" />
                </b-media>
            </b-media>
        </b-list-group-item>
    </b-list-group>
</template>

<script>
import Avatar from 'vue-avatar'

export default {
    name: 'ListUsers',
    props: ['users'],
    components: {
        Avatar,
    },
}
</script>
